const getTreatments = state => state.flags.treatments || {};

export default getTreatments;
